/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PhotoSeriesExportModal } from '../../../../../../components';
import { composeApiUrl } from '../../../../../../api/composeApiUrl';
import { makeGet } from '../../../../../../api/ajax';

const PhotoSeriesExportSection = ({ photoSeries, disabled }) => {
  const [shownExportPhotoSeriesModal, setShownExportPhotoSeriesModal] = useState(false);

  const handleExport = () => {
    if (!photoSeries.id) return;
    window.location = composeApiUrl(`photoSeries/${photoSeries.id}/export`);
  };

  const handleSendToAnalysis = () => {
    if (!photoSeries.id || photoSeries.damages?.length > 0) return;
    makeGet(`photoSeries/${photoSeries.id}/damageDetectionAnalysis`).subscribe(() => {
      setShownExportPhotoSeriesModal(false);
    });
  };

  if (!photoSeries) return null;

  return (
    <>
      <span
        onClick={() => {
          if (disabled) return;
          if (photoSeries.analyzedAt || photoSeries.completedAt === null) handleExport();
          else setShownExportPhotoSeriesModal(true);
        }}
        className="pl-1"
      >
        Export
      </span>
      <PhotoSeriesExportModal
        show={shownExportPhotoSeriesModal}
        onHide={() => setShownExportPhotoSeriesModal(false)}
        onExport={() => handleExport()}
        onSendToAnalysis={() => handleSendToAnalysis()}
        hasDamages={photoSeries.damages?.length > 0}
      />
    </>
  );
};

PhotoSeriesExportSection.propTypes = {
  photoSeries: PropTypes.object,
  disabled: PropTypes.bool.isRequired
};

export default PhotoSeriesExportSection;
